import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { MuiTelInput } from 'mui-tel-input';
import { FC } from 'react';
import GenderOptionLabel from '../../../components/Form/GenderOptionLabel';
import { GENDER_OPTIONS } from '../../../constants/gender';

export interface GuestFormState {
  fullName: string;
  email: string;
  phone: string;
  gender: string;
}

export type GuestFormField = keyof GuestFormState;

interface Props {
  guest: GuestFormState;
  onGuestChange: (field: GuestFormField, value: string) => void;
}

const GuestDetailForm: FC<Props> = ({ guest, onGuestChange }) => {
  return (
    <div className="flex flex-col gap-6 w-full">
      <span className="text-lg font-semibold text-neutral-800">
        Enter your details
      </span>
      <div className="flex flex-col items-start gap-4 self-stretch">
        <TextField
          label="Full name"
          onChange={e => onGuestChange('fullName', e.target.value)}
          value={guest.fullName}
          fullWidth
        />
        <FormControl fullWidth>
          <InputLabel id="payment-guest-gender-label">Gender</InputLabel>
          <Select
            labelId="payment-guest-gender-label"
            label="Gender"
            onChange={e => onGuestChange('gender', e.target.value)}
            value={guest.gender}
            displayEmpty
            renderValue={selected =>
              selected ? (
                <GenderOptionLabel gender={selected} />
              ) : (
                <em>Select gender</em>
              )
            }
          >
            <MenuItem value="">
              <em>Select gender</em>
            </MenuItem>
            {GENDER_OPTIONS.map(gender => (
              <MenuItem key={gender} value={gender}>
                <GenderOptionLabel gender={gender} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          onChange={e => onGuestChange('email', e.target.value)}
          value={guest.email}
          label="Email address"
          fullWidth
        />
        <MuiTelInput
          fullWidth
          value={guest.phone}
          onChange={value => onGuestChange('phone', value)}
        />
      </div>
    </div>
  );
};

export default GuestDetailForm;
